import React, { useState } from 'react';
import { Box } from '@mui/material';
import CoachPageLayout from '../../components/CoachPageLayout/CoachPageLayout';
import { PaginationModelChangeProps } from '../../components/ClientTable/ClientTable';
import TeamMembersTabs from '../../components/TeamMembersTabs/TeamMembersTabs';
import TeamMembersTable from '../../components/TeamMembersTable/TeamMembersTable/TeamMembersTable';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

export interface MembersProps {
  pageSize: number;
  currentPage: number;
  skip: number;
  handleOnPaginationModelChange: (_event: PaginationModelChangeProps) => void;
}

const TeamMembers = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  return (
    <CoachPageLayout>
      <Box sx={{ width: '50%', mb: 2 }}>
        <TeamMembersTabs value={selectedTab} setValue={setSelectedTab} />
      </Box>

      {checkPermissions(UserPermissionType.TEAM_MODULE_VIEW_COACH_GROUP) && (
        <TeamMembersTable isArchived={selectedTab === 1} />
      )}
    </CoachPageLayout>
  );
};

export default TeamMembers;
